
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import isEqual from 'lodash/isEqual';
import 'just-kebab-case';
import { e as capitalize, j as cached, h as hasSlot } from './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread, a as _slicedToArray } from './_rollupPluginBabelHelpers-mixin.js';
import kebabCase from 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import get from 'lodash/get';
import { f as PendoLoading$1, S as SkeletonLoader } from './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-button.js';
import { C as CollapseTransition } from './collapse-transition-mixin.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import PendoDivider from './pendo-divider.js';
import 'element-ui/lib/checkbox';
import PendoCheckbox from './pendo-checkbox.js';
import uniqueId from 'lodash/uniqueId';
import 'lodash/isNumber';
import { f as findNodeByContent, e as elementHasOverflow, h as elementPositionInAncestor, r as raf, g as getScrollParent, j as removeClass, k as addClass } from './table-auto-height-mixin.js';
import 'popper.js';
import uuid from 'uuid';
import { ResizeObserver } from 'vue-resize';
import clamp from 'lodash/clamp';
import { P as PickerPopover } from './picker-popover-mixin.js';
import isPlainObject from 'lodash/isPlainObject';
import debounce from 'lodash/debounce';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import ResizeObserver$1 from 'resize-observer-polyfill';
import './pendo-modal.js';
import isFunction from 'lodash/isFunction';
import { w as warn } from './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import './pendo-multiselect.js';
import PendoIconButton from './pendo-icon-button.js';
import PendoResponsive from './pendo-responsive.js';
import cloneDeep from 'lodash/cloneDeep';
import keyBy from 'lodash/keyBy';
import ScrollParent from 'scrollparent';
import { ObserveVisibility } from 'vue-observe-visibility';
import Checkbox from './pendo-checkbox-cell.js';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import './pendo-column-reorder.js';
import PendoColumnChooser from './pendo-column-chooser.js';
import groupBy from 'lodash/groupBy';

var script = {
  name: 'TableTitle',
  inject: ['$table'],
  components: {
    PendoIconButton,
    PendoDivider
  },
  directives: {
    PendoTooltip,
    PendoLoading: PendoLoading$1
  },
  computed: {
    showClearSelectedAction() {
      if (this.$table.checkboxConfig.selectAll === false) {
        return this.$table.isIndeterminate || this.$table.isAllSelected;
      }

      return false;
    },

    activeCountText() {
      const selectedCount = this.$table.getSelectedRows().length;
      const availableCount = this.$table.tableData.length;

      if (this.$table.isIndeterminate || this.$table.isAllSelected) {
        return `(${selectedCount} of ${availableCount} Selected)`;
      }

      return `(${availableCount})`;
    },

    manageColumnsTooltip() {
      return this.$table.manageColumnsConfig.title || 'Manage Columns';
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__title",
    style: _vm.$table.scrollStore.pageMode && {
      top: _vm.$table.scrollStore.stickyElementPositions.title + "px"
    },
    attrs: {
      "id": "title"
    }
  }, [_vm._t("header", [_vm._t("headerLeft", [_c('div', {
    staticClass: "pendo-table__title-info"
  }, [_c('div', {
    staticClass: "pendo-table__title-text"
  }, [_vm._v("\n                    " + _vm._s(_vm.$table.tableTitle) + "\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading:material",
      value: {
        loading: _vm.$table.loading,
        spinnerProps: {
          color: '#3a3c45',
          background: '#FFFFFF',
          size: 16
        }
      },
      expression: "{\n                        loading: $table.loading,\n                        spinnerProps: {\n                            color: '#3a3c45',\n                            background: '#FFFFFF',\n                            size: 16\n                        }\n                    }",
      arg: "material"
    }],
    staticClass: "pendo-table__active-count"
  }, [_vm.$table.data && _vm.$table.data.length ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.activeCountText) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _vm.showClearSelectedAction ? _c('div', {
    staticClass: "pendo-table__clear-selected pendo-table__link",
    on: {
      "click": _vm.$table.clearSelected
    }
  }, [_vm._v("\n                    Clear\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._t("headerRight", [_c('div', {
    staticClass: "pendo-table__title-actions"
  }, [_vm._t("headerActions"), _vm._v(" "), _vm.$table.csvDownload ? _c('pendo-icon-button', {
    staticClass: "pendo-table__title-action pendo-table__title-action--download",
    attrs: {
      "tooltip": "Download CSV",
      "icon": "download",
      "icon-size": "16"
    },
    on: {
      "click": _vm.$table.downloadTableData
    }
  }) : _vm._e(), _vm._v(" "), _vm.$table.manageColumns ? _c('pendo-icon-button', {
    staticClass: "pendo-table__title-action pendo-table__title-action--columns",
    attrs: {
      "tooltip": _vm.manageColumnsTooltip,
      "icon": "columns",
      "icon-size": "16"
    },
    on: {
      "click": _vm.$table.showManageColumnsModal
    }
  }) : _vm._e(), _vm._v(" "), _vm.$table.collapsible ? [_c('pendo-divider', {
    attrs: {
      "direction": "vertical",
      "width": "16px",
      "height": "24px",
      "stroke": "#DADCE5"
    }
  }), _vm._v(" "), _c('pendo-icon-button', {
    staticClass: "pendo-table__title-action pendo-table__title-action--collapse",
    attrs: {
      "tooltip": _vm.$table.collapseTooltipContent,
      "icon": "chevron-up",
      "icon-size": "16"
    },
    on: {
      "click": _vm.$table.toggleTableCollapse
    }
  })] : _vm._e()], 2)])])], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "table-title.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var TableTitle = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  components: {
    PendoIcon
  },
  inject: ['$table'],
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  computed: {
    isAscending() {
      if (this.$table.sortStore.column) {
        return this.$table.sortStore.column.property === this.column.property && this.$table.sortStore.activeSort === 'ascending';
      }

      return false;
    },

    isDescending() {
      if (this.$table.sortStore.column) {
        return this.$table.sortStore.column.property === this.column.property && this.$table.sortStore.activeSort === 'descending';
      }

      return false;
    }

  },
  methods: {
    sortAscending() {
      this.$table.setActiveSort(this.column.property, 'ascending');
    },

    sortDescending() {
      this.$table.setActiveSort(this.column.property, 'descending');
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__column-sort",
    class: {
      'is-ascending': _vm.isAscending,
      'is-descending': _vm.isDescending
    }
  }, [_c('pendo-icon', {
    staticClass: "column-sort--ascending",
    attrs: {
      "type": "sort-asc",
      "display": "grid",
      "fill": _vm.isAscending ? '#2A2C35' : undefined,
      "stroke": _vm.isAscending ? '#2A2C35' : '#9A9CA5',
      "size": "10",
      "stroke-width": "3"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.sortAscending($event);
      }
    }
  }), _vm._v(" "), _c('pendo-icon', {
    staticClass: "column-sort--descending",
    style: {
      transform: 'rotate(180deg)'
    },
    attrs: {
      "type": "sort-asc",
      "fill": _vm.isDescending ? '#2A2C35' : undefined,
      "stroke": _vm.isDescending ? '#2A2C35' : '#9A9CA5',
      "display": "grid",
      "size": "10",
      "stroke-width": "3"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.sortDescending($event);
      }
    }
  })], 1);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "sort-controls.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var SortControls = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  inheritAttrs: false,
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  inject: ['$table'],
  computed: {
    expanded() {
      if (this.row) {
        return Boolean(this.$table.treeExpandedMap[this.row[this.$table.rowKey]]);
      }

      return this.$table.isAllTreeExpanded;
    }

  },
  methods: {
    handleExpand() {
      if (this.row) {
        this.$table.toggleRowTreeExpand(this.row);
      } else {
        this.$table.toggleAllRowsTreeExpand();
      }
    }

  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "pendo-table__tree-expand",
    class: {
      'is-expanded': _vm.expanded
    },
    on: {
      "click": _vm.handleExpand
    }
  }, [_c('i', {
    staticClass: "pendo-icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "display": "block"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), !_vm.expanded ? _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "16"
    }
  }) : _vm._e(), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "12",
      "x2": "16",
      "y2": "12"
    }
  })])])]);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "tree.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Tree = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

var script$3 = {
  components: {
    PendoCheckbox,
    PendoIcon,
    PickerPopover
  },
  inject: ['$table'],
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  computed: {
    isFilterPanelVisible() {
      return this.$table.filterStore.column === this.column && this.$table.filterStore.visible;
    },

    isColumnFiltered() {
      return this.column.filters.some(({
        checked
      }) => !!checked);
    }

  },
  methods: {
    hideFilterPanel() {
      this.$table.hideFilterPanel();
    },

    showFilterPanel() {
      this.$table.showFilterPanel(this.column);
    },

    handleFilterChange(value, option, optionIndex) {
      this.$table.filterColumn({
        value,
        option,
        optionIndex,
        column: this.column
      });
    }

  }
};

const __vue_script__$3 = script$3;

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__column-filters",
    class: {
      'is-open': _vm.isFilterPanelVisible
    }
  }, [_c('picker-popover', {
    attrs: {
      "is-open": _vm.isFilterPanelVisible,
      "append-to-body": "",
      "full-width": "",
      "popper-options": {
        placement: 'bottom-end',
        modifiers: {
          flipVariations: {
            enabled: false
          }
        }
      }
    },
    on: {
      "click-outside": _vm.hideFilterPanel
    },
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function () {
        return [_c('div', {
          staticClass: "pendo-table__filters-panel"
        }, _vm._l(_vm.$table.filterStore.options, function (option, optionIndex) {
          return _c('pendo-checkbox', {
            key: optionIndex,
            attrs: {
              "value": option.checked,
              "label": option.label
            },
            on: {
              "change": function ($event) {
                return _vm.handleFilterChange($event, option, optionIndex);
              }
            }
          });
        }), 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pendo-table__filters-trigger",
    class: {
      'is-active': _vm.isColumnFiltered,
      'is-open': _vm.isFilterPanelVisible
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.showFilterPanel($event);
      }
    }
  }, [_c('pendo-icon', {
    attrs: {
      "type": "filter",
      "size": "14",
      "fill": _vm.isColumnFiltered ? '#9A9CA5' : undefined,
      "stroke": "#9A9CA5"
    }
  })], 1)])], 1);
};

var __vue_staticRenderFns__$3 = [];
const __vue_inject_styles__$3 = undefined;
const __vue_scope_id__$3 = undefined;
const __vue_is_functional_template__$3 = false;

function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "filter-panel.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var FilterPanel = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3);

PendoTooltip.options.disposeTimeout = 0;
var TableHeaderCell = {
  name: 'TableHeaderCell',
  inject: ['$table'],
  components: {
    SortControls,
    Checkbox,
    Tree,
    FilterPanel,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    column: {
      type: Object
    },
    columnIndex: {
      type: Number
    }
  },

  data() {
    return {
      tooltipContent: null
    };
  },

  computed: {
    fixedColumnStyle() {
      if (this.$table.overflowX) {
        if (this.column.fixed === 'left') {
          return {
            left: `${this.column.fixedPos}px`
          };
        }

        if (this.column.fixed === 'right') {
          return {
            right: `${this.column.fixedPos}px`
          };
        }
      }
    },

    headerCellClassName() {
      if (this.$table.headerCellClassName) {
        return isFunction(this.$table.headerCellClassName) ? this.$table.headerCellClassName({
          row: {},
          column: this.column
        }) : this.$table.headerCellClassName;
      }

      return '';
    },

    isFiltered() {
      if (this.column.filters) {
        return this.column.filters.some(col => col.checked);
      }

      return false;
    },

    isFixedRight() {
      return this.column.fixed === 'right' && this.$table.overflowX && this.$table.scrollRightToLeft;
    },

    isFixedLeft() {
      return this.column.fixed === 'left' && this.$table.overflowX && this.$table.scrollLeftToRight;
    },

    isSorted() {
      if (this.$table.sortStore.column) {
        return this.$table.sortStore.column.property === this.column.property;
      }

      return false;
    },

    isHover() {
      return this.columnIndex === this.$table.hoverColumnHeader || this.$table.filterStore.column === this.column && this.$table.filterStore.visible;
    },

    showEllipsis() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === 'ellipsis';
    },

    showTitle() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === 'title';
    },

    showTooltip() {
      if (['actions', 'index', 'checkbox', 'expand', 'tree'].includes(this.column.type)) {
        return false;
      }

      return this.column.showOverflow === true || this.column.showOverflow === 'tooltip' || this.$table.showAllOverflow === true || this.$table.showAllOverflow === 'tooltip';
    }

  },
  methods: {
    handleCellMouseenter({
      currentTarget
    }) {
      this.$table.toggleColumnHeaderHover(this.column, this.columnIndex);
      const cellContentNode = findNodeByContent(this.column.label, currentTarget);

      if (!cellContentNode.length) {
        this.tooltipContent = null;
        return;
      }

      if (elementHasOverflow(cellContentNode[0])) {
        requestAnimationFrame(() => {
          this.tooltipContent = this.column.label;
        });
      } else {
        this.tooltipContent = null;
      }
    },

    handleCellMouseleave() {
      this.$table.toggleColumnHeaderHover();
    },

    handleResizeMousedown($event) {
      this.$emit('resize', $event, this.column, this.columnIndex);
    },

    onCheckboxChange($event) {
      this.$table.toggleAllRowsSelect($event.target.checked);
    },

    toggleSort($event) {
      $event.stopPropagation();

      if (this.column.sortable) {
        return this.$table.setActiveSort(this.column.property);
      }
    }

  },

  render(createElement) {
    const $table = this.$table,
          column = this.column,
          columnIndex = this.columnIndex,
          isFiltered = this.isFiltered,
          isFixedRight = this.isFixedRight,
          isFixedLeft = this.isFixedLeft,
          isHover = this.isHover,
          isSorted = this.isSorted,
          fixedColumnStyle = this.fixedColumnStyle,
          handleResizeMousedown = this.handleResizeMousedown,
          headerCellClassName = this.headerCellClassName,
          onCheckboxChange = this.onCheckboxChange,
          showTooltip = this.showTooltip,
          showEllipsis = this.showEllipsis,
          tooltipContent = this.tooltipContent;
    const colSpan = column.colSpan,
          filters = column.filters,
          label = column.label,
          property = column.property,
          rowSpan = column.rowSpan,
          sortable = column.sortable,
          type = column.type;

    function renderChildren() {
      let children = label;
      const slotName = `${type || property}Header`;

      if ($table.$scopedSlots && $table.$scopedSlots[slotName]) {
        children = $table.$scopedSlots[slotName]({
          column,
          columnIndex
        });
      }

      if (type) {
        switch (type) {
          case 'checkbox':
            if ($table.checkboxConfig.headerLabel) {
              children = $table.checkboxConfig.headerLabel;
            } else if ($table.checkboxConfig.selectAll !== false) {
              children = createElement(Checkbox, {
                props: {
                  checked: $table.isAllSelected,
                  indeterminate: $table.isIndeterminate
                },
                on: {
                  change: onCheckboxChange
                }
              });
            }

            break;

          case 'tree':
            if ($table.treeConfig.expandAll !== false) {
              children = createElement(Tree);
            }

            break;

          case 'index':
            children = label || '#';
            break;

          default:
            children = label;
            break;
        }
      }

      return createElement('span', [children]);
    }

    function renderActions() {
      const isColumnSortActive = isSorted && ['ascending', 'descending'].includes($table.sortStore.activeSort);

      if (isHover || isColumnSortActive) {
        const children = [];

        if (filters && filters.length) {
          children.push(createElement(FilterPanel, {
            props: {
              column
            }
          }));
        }

        if (sortable) {
          children.push(createElement(SortControls, {
            props: {
              column
            }
          }));
        }

        return createElement('div', {
          class: 'pendo-table__column-actions'
        }, children);
      }

      return null;
    }

    function renderResizeControl() {
      if ($table.resizable && column.allowResize) {
        return createElement('div', {
          class: 'pendo-table__resizable',
          on: {
            mousedown: handleResizeMousedown
          }
        });
      }

      return null;
    }

    return createElement('th', {
      class: ['pendo-table__column', headerCellClassName, {
        'pendo-table__column--sortable': column.sortable,
        'pendo-table__column--filterable': column.filters && column.filters.length,
        'pendo-table__column--center': column.headerAlign === 'center',
        'pendo-table__column--right': column.headerAlign === 'right',
        'pendo-table__column--fixed-left': column.fixed === 'left' && $table.overflowX,
        'pendo-table__column--fixed-right': column.fixed === 'right' && $table.overflowX,
        'pendo-table__column--fixed-shadow': column.fixedShadow,
        'is-hover': isHover,
        'is-fixed-left': isFixedLeft,
        'is-fixed-right': isFixedRight,
        'is-filtered': isFiltered
      }],
      attrs: {
        'aria-sort': isSorted && $table.sortStore.activeSort,
        scope: 'col',
        rowspan: rowSpan,
        colspan: colSpan
      },
      style: fixedColumnStyle,
      on: {
        mouseenter: this.handleCellMouseenter,
        mouseleave: this.handleCellMouseleave,
        click: this.toggleSort
      }
    }, [createElement('div', {
      class: ['pendo-table__cell', {
        'pendo-table__cell--index': column.type === 'index',
        'pendo-table__cell--tooltip': showTooltip,
        'pendo-table__cell--tree': column.type === 'tree',
        'pendo-table__cell--checkbox': column.type === 'checkbox',
        'pendo-table__cell--ellipsis': showEllipsis
      }],
      directives: [{
        name: 'pendo-tooltip',
        value: {
          content: tooltipContent,
          delay: {
            show: 300,
            hide: 0
          },
          arrow: true,
          multiline: true,
          html: false,
          boundariesElement: 'body'
        }
      }]
    }, [renderChildren(), renderActions(), renderResizeControl()])]);
  }

};

const normalizeValue = cached(value => {
  return value.toString().toLowerCase().trim();
});
let columnId = 0;
function flattenChildRows(data, opts) {
  return data.reduce((acc, row) => {
    acc.push(row);

    if (row[opts.childKey] && opts.childRowFilter(row)) {
      acc.push(...flattenChildRows(row[opts.childKey], opts));
    }

    return acc;
  }, []);
}
function capitalizeColumnLabel(str) {
  str = str.split(' ');

  for (let i = 0, x = str.length; i < x; i++) {
    str[i] = capitalize(str[i]);
  }

  return str.join(' ');
}
function getColumnConfig(column) {
  if (['tree', 'checkbox', 'expand', 'index'].includes(column.type)) {
    column = _objectSpread({}, column, {
      width: column.width || 36,
      widthType: 'fixed',
      sortable: false,
      visible: true,
      downloadable: false,
      allowResize: false,
      allowReorder: false
    });
  }

  if (column.type === 'actions') {
    column.allowResize = false;
    column.allowReorder = false;
    column.downloadable = false;
  }

  if (column.label && !column.width) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = '700 14px "Inter", Helvetica Neue, Arial, sans-serif';
    const label = capitalizeColumnLabel(column.label);
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    let _ctx$measureText = ctx.measureText(label),
        width = _ctx$measureText.width;

    column.labelWidth = width;
    width += 32;

    if (column.sortable) {
      width += 26;
    }

    if (column.filters) {
      width += 26;
    }

    let minWidth;

    if (column.minWidth) {
      minWidth = Math.max(column.minWidth, Math.ceil(width));
    } else {
      minWidth = Math.min(Math.ceil(width), 280);
    }

    column.minWidth = minWidth;
    column.widthType = column.widthType || 'flex';
  }

  if (!column.width && !column.minWidth) {
    warn(`no width or minWidth detected for column '${column.prop}'`);
    column.minWidth = 36;
    column.widthType = 'flex';
  }

  if (column.width) {
    column.widthType = 'fixed';
  }

  return {
    align: column.align,
    allowResize: column.allowResize !== false,
    allowReorder: column.allowReorder !== false,
    append: column.append,
    async: !!column.async,
    colSpan: 1,
    columnKey: column.columnKey || column.prop || column.property || column.type,
    downloadable: column.downloadable !== false,
    exact: column.exact,
    filterMethod: column.filterMethod,
    filterMultiple: column.filterMultiple,
    filters: (column.filters || []).map(({
      label,
      value
    }) => ({
      prop: column.prop,
      label,
      value,
      checked: false
    })),
    fixed: column.fixed === true || column.fixed === 'left' ? 'left' : column.fixed,
    fixedPos: 0,
    fixedShadow: false,
    formatter: column.formatter,
    headerAlign: column.headerAlign,
    href: column.href,
    id: `col--${++columnId}`,
    indexMethod: column.indexMethod,
    label: column.label,
    labelWidth: column.labelWidth || column.minWidth,
    level: 1,
    minWidth: column.minWidth || 120,
    order: column.sortable ? column.order || 'none' : null,
    property: column.prop || column.property,
    renderHeight: 0,
    renderWidth: 0,
    replace: column.replace,
    resizeWidth: column.resizeWidth || 0,
    rowSpan: 1,
    showOverflow: column.showOverflow === false ? false : column.showOverflow || column.showOverflowTooltip || true,
    slot: column.slot,
    sortable: column.sortable,
    sortBy: column.sortBy,
    sortMethod: column.sortMethod,
    target: column.target,
    to: column.to,
    treeNode: column.treeNode,
    type: column.type,
    visible: column.visible,
    width: column.width,
    widthType: column.widthType
  };
}
let scrollBarWidth;
function getScrollbarWidth() {
  if (scrollBarWidth !== undefined) {
    return scrollBarWidth;
  }

  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);
  const widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  const widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;
  return scrollBarWidth;
}
function getProp(target, key) {
  return get(target, key);
}
function emitEvent(_vm, type, args) {
  if (_vm.$listeners[type] || _vm._events[type]) {
    _vm.$emit(...[type].concat(args));
  }
}

var script$4 = {
  name: 'TableHeader',
  components: {
    TableHeaderCell
  },
  inject: ['$table'],

  data() {
    return {
      dragStore: {},
      observer: undefined
    };
  },

  computed: {
    headerRowClassName() {
      if (this.$table.headerRowClassName) {
        return isFunction(this.$table.headerRowClassName) ? this.$table.headerRowClassName({
          row: {}
        }) : this.$table.headerRowClassName;
      }

      return '';
    }

  },
  methods: {
    handleResizeMousedown(event, column, columnIndex) {
      const target = event.target;

      const _elementPositionInAnc = elementPositionInAncestor(target, this.$table.$el),
            left = _elementPositionInAnc.left,
            top = _elementPositionInAnc.top;

      const tableScrollLeft = this.$table.scrollStore.scrollLeft;
      const tableClientRect = this.$table.$el.getBoundingClientRect();
      const tableRightBoundary = tableClientRect.right - tableClientRect.left;
      const columnEl = target.closest('th.pendo-table__column');
      const columnElPos = elementPositionInAncestor(columnEl, this.$el);
      const colScrollLeft = columnElPos.left - tableScrollLeft;
      this.dragStore = {
        minLeft: colScrollLeft + column.minWidth - 3,
        maxRight: column.fixed === 'left' ? tableRightBoundary - 96 : Infinity,
        posLeft: left + 2 - tableScrollLeft,
        posTop: top,
        clientX: event.clientX,
        dragLeft: 0,
        column,
        columnIndex
      };
      this.$el.classList.toggle('is-dragging');
      this.$table.$refs.resizeBar.style.top = `${top}px`;
      this.$table.$refs.resizeBar.style.display = 'block';
      document.addEventListener('mousemove', this.handleResizeMousemove);
      document.addEventListener('mouseup', this.handleResizeMouseup);
      this.handleResizeMousemove(event);
    },

    handleResizeMousemove(event) {
      event.preventDefault();
      const _this$dragStore = this.dragStore,
            clientX = _this$dragStore.clientX,
            posLeft = _this$dragStore.posLeft,
            minLeft = _this$dragStore.minLeft,
            posTop = _this$dragStore.posTop,
            maxRight = _this$dragStore.maxRight;
      const offsetX = event.clientX - clientX;
      const left = posLeft + offsetX;
      const dragLeft = clamp(left, minLeft, maxRight);
      this.$table.$refs.resizeBar.style.left = `${dragLeft}px`;
      this.$table.$refs.resizeBar.style.top = `${posTop}px`;
      this.dragStore.dragLeft = dragLeft;
    },

    handleResizeMouseup(event) {
      event.preventDefault();
      document.removeEventListener('mousemove', this.handleResizeMousemove);
      document.removeEventListener('mouseup', this.handleResizeMouseup);
      const _this$dragStore2 = this.dragStore,
            posLeft = _this$dragStore2.posLeft,
            dragLeft = _this$dragStore2.dragLeft,
            column = _this$dragStore2.column,
            columnIndex = _this$dragStore2.columnIndex;
      const width = column.renderWidth - (posLeft - dragLeft);
      this.$table.tableColumns[columnIndex].widthType = 'resize';
      this.$table.tableColumns[columnIndex].resizeWidth = Math.max(width, column.minWidth);
      this.$el.classList.toggle('is-dragging');
      this.$table.$refs.resizeBar.style.display = 'none';
      this.dragStore = {};
      requestAnimationFrame(() => {
        this.$table.refreshLayout();
        const column = this.$table.tableColumns[columnIndex];
        emitEvent(this.$table, 'column-resize', [{
          column: column.property,
          width: column.resizeWidth
        }]);
      });
    }

  }
};

const __vue_script__$4 = script$4;

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__header",
    style: _vm.$table.scrollStore.pageMode && {
      top: _vm.$table.scrollStore.stickyElementPositions.header + "px"
    }
  }, [_c('table', {
    style: {
      width: _vm.$table.bodyWidth === null ? _vm.$table.bodyWidth : _vm.$table.bodyWidth + "px"
    },
    attrs: {
      "aria-colcount": _vm.$table.tableColumns.length,
      "aria-rowcount": "1",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', [_vm._l(_vm.$table.tableColumns, function (column, columnIndex) {
    return _c('col', {
      key: columnIndex,
      attrs: {
        "name": column.id,
        "width": column.renderWidth
      }
    });
  }), _vm._v(" "), _vm.$table.verticalScrollbarWidth ? _c('col', {
    attrs: {
      "width": _vm.$table.verticalScrollbarWidth
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('thead', [_c('tr', {
    class: _vm.headerRowClassName
  }, [_vm._l(_vm.$table.tableColumns, function (column, columnIndex) {
    return _c('table-header-cell', {
      key: column.columnKey || columnIndex,
      ref: "column",
      refInFor: true,
      attrs: {
        "column": column,
        "column-index": columnIndex
      },
      on: {
        "resize": _vm.handleResizeMousedown
      }
    });
  }), _vm._v(" "), _vm.$table.verticalScrollbarWidth ? _c('th', {
    staticClass: "pendo-table__column",
    style: {
      width: _vm.$table.verticalScrollbarWidth + "px"
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pendo-table__repair",
    style: {
      width: _vm.$table.bodyWidth + "px"
    }
  })]);
};

var __vue_staticRenderFns__$4 = [];
const __vue_inject_styles__$4 = undefined;
const __vue_scope_id__$4 = undefined;
const __vue_is_functional_template__$4 = false;

function __vue_normalize__$4(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "table-header.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var TableHeader = __vue_normalize__$4({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4);

var script$5 = {
  name: 'TableRow',
  inject: ['$table'],
  props: {
    index: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    isExpanded() {
      return Boolean(this.$table.expandedMap[this.row[this.$table.rowKey]]);
    },

    isTreeExpanded() {
      return Boolean(this.$table.treeExpandedMap[this.row[this.$table.rowKey]]);
    },

    isChild() {
      return Boolean(this.$table.treeExpandedChildMap[this.row[this.$table.rowKey]]);
    },

    isActive() {
      return this.row[this.$table.rowKey] === this.$table.activeRow;
    },

    isSelected() {
      return Boolean(this.$table.selectedMap[this.row[this.$table.rowKey]]);
    },

    isGroupRow() {
      return this.row.isGroup;
    },

    rowClassName() {
      if (this.$table.rowClassName) {
        return isFunction(this.$table.rowClassName) ? this.$table.rowClassName({
          row: this.row,
          rowIndex: this.index
        }) : this.$table.rowClassName;
      }

      return '';
    }

  }
};

const __vue_script__$5 = script$5;

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('tr', {
    staticClass: "pendo-table__row",
    class: [_vm.rowClassName, {
      'pendo-table__row--child pendo-table__row--expand': _vm.isChild,
      'pendo-table__row--group': _vm.isGroupRow,
      'is-active': _vm.isActive,
      'is-expanded': _vm.isTreeExpanded || _vm.isExpanded,
      'is-selected': _vm.isSelected
    }],
    attrs: {
      "role": "row"
    },
    on: {
      "mouseenter": function ($event) {
        return _vm.$table.setRowHover(_vm.row, _vm.index);
      }
    }
  }, [_vm._t("default", null, {
    "naturalIndex": _vm.index + 1,
    "rowIndex": _vm.index
  })], 2);
};

var __vue_staticRenderFns__$5 = [];
const __vue_inject_styles__$5 = undefined;
const __vue_scope_id__$5 = undefined;
const __vue_is_functional_template__$5 = false;

function __vue_normalize__$5(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "table-row.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var TableRow = __vue_normalize__$5({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5);

var script$6 = {
  inheritAttrs: false,
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  inject: ['$table'],
  computed: {
    expanded() {
      return this.$table.expandedMap[this.row[this.$table.rowKey]];
    }

  },
  methods: {
    toggleRowExpand() {
      this.$table.toggleRowExpand(this.row);
    }

  }
};

const __vue_script__$6 = script$6;

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "pendo-table__expand",
    class: {
      'is-expanded': _vm.expanded
    },
    on: {
      "click": _vm.toggleRowExpand
    }
  }, [_c('i', {
    staticClass: "pendo-icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "display": "block"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "9 18 15 12 9 6"
    }
  })])])]);
};

var __vue_staticRenderFns__$6 = [];
const __vue_inject_styles__$6 = undefined;
const __vue_scope_id__$6 = undefined;
const __vue_is_functional_template__$6 = false;

function __vue_normalize__$6(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "expand.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Expand = __vue_normalize__$6({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6);

var script$7 = {
  inheritAttrs: false,
  inject: ['$table'],
  props: {
    column: {
      type: Object,
      required: true
    },
    content: {
      type: [String, Number],
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      emitEvent(this.$table, 'link-click', [{
        row: this.row,
        column: this.column
      }]);
    },

    generateRouteLink() {
      let tag = 'a';
      const data = {
        attrs: {
          tabindex: this.$attrs.tabindex
        },
        class: 'pendo-table__link',
        props: {},
        [this.column.to ? 'nativeOn' : 'on']: {
          click: this.handleClick
        },
        ref: 'link'
      };

      if (this.column.href) {
        let href = this.column.href;

        if (typeof href === 'function') {
          href = this.column.href(this.row);
        }

        if (!href) {
          tag = 'div';
        }

        data.attrs.href = href;
      }

      if (this.column.to) {
        tag = 'router-link';
        const type = typeof this.column.to;
        let to;
        let exact;

        if (['object', 'string'].includes(type)) {
          to = this.column.to;
        } else if (type === 'function') {
          to = this.column.to(this.row);
        }

        if (typeof this.column.exact === 'undefined') {
          exact = this.column.to === '/' || this.column.to === Object(this.column.to) && this.column.to.path === '/';
        }

        if (!to) {
          tag = 'div';
        }

        Object.assign(data.props, {
          to,
          exact,
          append: this.column.append,
          replace: this.column.replace
        });
      }

      if (this.column.target) {
        data.attrs.target = this.column.target;
      }

      return {
        tag,
        data
      };
    }

  },

  render(createElement) {
    const _this$generateRouteLi = this.generateRouteLink(),
          tag = _this$generateRouteLi.tag,
          data = _this$generateRouteLi.data;

    return createElement(tag, tag === 'div' ? null : data, this.content);
  }

};

const __vue_script__$7 = script$7;
const __vue_inject_styles__$7 = undefined;
const __vue_scope_id__$7 = undefined;
const __vue_is_functional_template__$7 = undefined;

function __vue_normalize__$7(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "link.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Link = __vue_normalize__$7({}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7);

PendoTooltip.options.disposeTimeout = 0;
var TableCell = {
  name: 'TableCell',
  inject: ['$table'],
  components: {
    Checkbox,
    Expand,
    Link,
    SkeletonLoader,
    Tree
  },
  directives: {
    PendoTooltip
  },
  props: {
    column: {
      type: Object
    },
    columnIndex: {
      type: Number
    },
    naturalIndex: {
      type: Number
    },
    row: {
      type: Object
    },
    rowIndex: {
      type: Number
    },
    rowLevel: {
      type: Number
    }
  },

  data() {
    return {
      tooltipContent: null
    };
  },

  computed: {
    fixedColumnStyle() {
      const style = {};

      if (this.$table.overflowX) {
        if (this.column.fixed === 'left') {
          style.left = `${this.column.fixedPos}px`;
        }

        if (this.column.fixed === 'right') {
          style.right = `${this.column.fixedPos}px`;
        }
      }

      if (this.row.height) {
        style.height = `${this.row.height}px`;
      }

      return style;
    },

    cellClassName() {
      if (this.$table.cellClassName) {
        return isFunction(this.$table.cellClassName) ? this.$table.cellClassName({
          row: this.row,
          rowIndex: this.rowIndex,
          column: this.column,
          columnIndex: this.columnIndex
        }) : this.$table.cellClassName;
      }

      return '';
    },

    cellContentStyle() {
      const style = {};
      const useProvidedRowHeight = !this.$table.scrollStore.rowHeight && this.row.height;

      if (useProvidedRowHeight) {
        style.maxHeight = `${this.row.height}px`;
      }

      if (this.$table.border) {
        style.width = `${this.column.renderWidth - 1}px`;
        return style;
      }

      style.width = `${this.column.renderWidth}px`;
      return style;
    },

    cellContent() {
      if (this.column.formatter) {
        return this.column.formatter(this.row, this.column);
      }

      const rowValue = getProp(this.row, this.column.property);

      if (rowValue === 0) {
        return rowValue;
      }

      if (typeof rowValue === 'boolean') {
        return String(rowValue);
      }

      return rowValue || '';
    },

    clickListener() {
      if (['index', 'checkbox', 'expand', 'tree'].includes(this.column.type)) {
        return null;
      }

      if (this.$table.highlightCurrentRow || this.$table.$listeners['cell-click']) {
        return 'click';
      }

      return null;
    },

    hoverListener() {
      if (this.$table.scrollStore.scrollActive) {
        return null;
      }

      return this.showTooltip ? 'mouseenter' : null;
    },

    showClamp() {
      return this.column.showOverflow === 'clamp';
    },

    showEllipsis() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === 'ellipsis';
    },

    showTitle() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === 'title';
    },

    showTooltip() {
      if (['actions', 'index', 'checkbox', 'expand', 'tree'].includes(this.column.type)) {
        return false;
      }

      return this.column.showOverflow === true || this.column.showOverflow === 'clamp' || this.column.showOverflow === 'tooltip' || this.$table.showAllOverflow === true || this.$table.showAllOverflow === 'clamp' || this.$table.showAllOverflow === 'tooltip';
    },

    scrollActive() {
      return this.$table.scrollStore.scrollActive;
    },

    showLoading() {
      if (!this.column.async) {
        return false;
      }

      if (this.cellContent === 0) {
        return false;
      }

      return !this.cellContent;
    },

    showTreeExpand() {
      return this.$table.treeConfig && this.row[this.$table.treeConfig.children];
    }

  },
  watch: {
    scrollActive(active) {
      if (active) {
        this.tooltipContent = null;
      }
    }

  },
  methods: {
    onCellClick(event) {
      this.$table.handleCellClick(event, {
        row: this.row,
        column: this.column,
        cell: event.currentTarget
      });
    },

    onCellHover({
      currentTarget
    }) {
      const cellContentNode = findNodeByContent(this.cellContent, currentTarget);

      if (!cellContentNode.length) {
        this.tooltipContent = null;
        return;
      }

      if (elementHasOverflow(cellContentNode[0])) {
        requestAnimationFrame(() => {
          this.tooltipContent = this.cellContent;
        });
      } else {
        this.tooltipContent = null;
      }
    },

    onCheckboxChange() {
      this.$table.toggleRowSelect({
        row: this.row
      });
    }

  },

  render(createElement) {
    const row = this.row,
          rowIndex = this.rowIndex,
          rowLevel = this.rowLevel,
          column = this.column,
          columnIndex = this.columnIndex,
          cellContent = this.cellContent,
          naturalIndex = this.naturalIndex,
          cellClassName = this.cellClassName,
          cellContentStyle = this.cellContentStyle,
          fixedColumnStyle = this.fixedColumnStyle,
          showTooltip = this.showTooltip,
          showClamp = this.showClamp,
          showEllipsis = this.showEllipsis,
          clickListener = this.clickListener,
          hoverListener = this.hoverListener,
          onCellClick = this.onCellClick,
          onCellHover = this.onCellHover,
          onCheckboxChange = this.onCheckboxChange,
          tooltipContent = this.tooltipContent,
          $table = this.$table,
          showLoading = this.showLoading,
          showTreeExpand = this.showTreeExpand;
    let children = cellContent;
    let isTextNode = true;
    const slot = column.slot || column.type || column.property;

    if ($table.$scopedSlots && $table.$scopedSlots[slot] && !showLoading) {
      isTextNode = false;
      children = $table.$scopedSlots[slot]({
        row,
        rowIndex,
        column,
        columnIndex,
        toggleRowActive: $table.toggleRowActive
      });
    }

    if (column && column.type) {
      isTextNode = false;

      switch (column.type) {
        case 'checkbox':
          children = createElement(Checkbox, {
            props: {
              checked: Boolean($table.selectedMap[row[$table.rowKey]]),
              disabled: $table.checkboxConfig.checkMethod && !$table.checkboxConfig.checkMethod(row)
            },
            on: {
              change: onCheckboxChange
            }
          });
          break;

        case 'expand':
        case 'link':
          children = createElement(capitalize(column.type), {
            props: {
              row,
              rowLevel,
              column,
              content: children
            }
          });
          break;

        case 'tree':
          if (showTreeExpand) {
            children = createElement(Tree, {
              props: {
                row,
                rowLevel
              }
            });
          }

          break;

        case 'index':
          children = naturalIndex;
          break;

        case 'actions':
          const scrollActive = $table.scrollStore.scrollActive;
          const childRow = rowLevel > 0;

          if (scrollActive || childRow) {
            children = [];
            break;
          }

          const hoverRow = row[$table.rowKey] === $table.hoverRow;
          const activeRow = row[$table.rowKey] === $table.activeRow;

          if (!hoverRow && !activeRow) {
            children = [];
            break;
          }

      }
    }

    return createElement('td', {
      class: ['pendo-table__column', cellClassName, {
        'pendo-table__column--actions': column.type === 'actions',
        'pendo-table__column--center': column.align === 'center',
        'pendo-table__column--right': column.align === 'right',
        'pendo-table__column--fixed-left': $table.overflowX && column.fixed === 'left',
        'pendo-table__column--fixed-right': $table.overflowX && column.fixed === 'right',
        'pendo-table__column--fixed-shadow': column.fixedShadow,
        'is-fixed-actions': !$table.scrollStore.scrollActive && $table.overflowX && column.type === 'actions',
        'is-fixed-left': $table.overflowX && $table.scrollLeftToRight && column.fixed === 'left',
        'is-fixed-right': $table.overflowX && $table.scrollRightToLeft && column.fixed === 'right'
      }],
      style: fixedColumnStyle,
      on: _objectSpread({}, clickListener ? {
        click: onCellClick
      } : {}, hoverListener ? {
        mouseenter: onCellHover
      } : {})
    }, [createElement('div', {
      class: ['pendo-table__cell', {
        'pendo-table__cell--index': column.type === 'index',
        'pendo-table__cell--text': isTextNode,
        'pendo-table__cell--tooltip': showTooltip,
        'pendo-table__cell--checkbox': column.type === 'checkbox',
        'pendo-table__cell--tree': column.type === 'tree' && showTreeExpand,
        'pendo-table__cell--ellipsis': showEllipsis,
        'pendo-table__cell--clamp': showClamp
      }],
      style: cellContentStyle,
      directives: [{
        name: 'pendo-tooltip',
        value: {
          content: tooltipContent,
          delay: {
            show: 300,
            hide: 0
          },
          arrow: true,
          multiline: true,
          html: false,
          boundariesElement: 'body'
        }
      }]
    }, [showLoading ? createElement(SkeletonLoader, {
      props: {
        containerWidth: Math.max(0, parseInt(column.renderWidth - 32)),
        containerHeight: 8,
        skeletonProps: {
          animate: true,
          borderRadius: 2,
          height: 8,
          primaryColor: '#eaecf1',
          secondaryColor: '#f8f8f9',
          speed: 2,
          width: Math.max(0, parseInt(column.renderWidth - 32))
        }
      }
    }) : children])]);
  }

};

var TableSlot = {
  name: 'TableSlot',
  inject: ['$table'],
  props: {
    name: String,
    row: Object,
    rowIndex: Number,
    columnIndex: Number,
    column: {
      type: Object,
      default: null
    }
  },

  render(createElement) {
    const name = this.name,
          row = this.row,
          rowIndex = this.rowIndex,
          column = this.column,
          columnIndex = this.columnIndex,
          $table = this.$table;
    const children = $table.$scopedSlots[name]({
      row,
      rowIndex,
      column,
      columnIndex,
      toggleRowActive: $table.toggleRowActive
    });
    return createElement('div', {
      class: 'pendo-table__cell'
    }, [children]);
  }

};

let uid = 0;
var script$8 = {
  components: {
    TableRow,
    TableCell,
    TableSlot,
    ResizeObserver,
    PendoResponsive
  },
  inject: ['$table'],

  data() {
    return {
      ready: false,
      scheduleRowUpdate: null
    };
  },

  watch: {
    '$table.tableData': {
      handler() {
        this.updateVisibleRows();
      }

    }
  },

  async mounted() {
    if (this.$table.scrollStore.pageMode) {
      this.addPageModeListeners();
    }

    this.scheduleRowUpdate = raf(this.updateVisibleRows);
    this.syncScrollPositions = raf(this.syncScrollPositions);
    await this.$nextTick();
    this.updateVisibleRows();
    this.ready = true;
  },

  beforeDestroy() {
    this.removePageModeListeners();
  },

  methods: {
    getScroll() {
      if (this.$table.scrollStore.pageMode) {
        const _this$$el$getBounding = this.$el.getBoundingClientRect(),
              top = _this$$el$getBounding.top,
              height = _this$$el$getBounding.height;

        let start = -top;
        let size = window.innerHeight;

        if (start < 0) {
          size += start;
          start = 0;
        }

        if (start + size > height) {
          size = height - start;
        }

        return {
          start,
          end: start + size
        };
      }

      return {
        start: this.$el.scrollTop,
        end: this.$el.scrollTop + this.$el.clientHeight
      };
    },

    getPageModeListenerTarget() {
      let target = ScrollParent(this.$el);

      if (window.document && (target === window.document.documentElement || target === window.document.body)) {
        target = window;
      }

      return target;
    },

    addPageModeListeners() {
      this.pageModeListenerTarget = this.getPageModeListenerTarget();
      this.pageModeListenerTarget.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
      this.pageModeListenerTarget.addEventListener('resize', this.handleResize);
    },

    removePageModeListeners() {
      if (!this.pageModeListenerTarget) {
        return;
      }

      this.pageModeListenerTarget.removeEventListener('scroll', this.handleScroll);
      this.pageModeListenerTarget.removeEventListener('resize', this.handleResize);
      this.pageModeListenerTarget = null;
    },

    handleResize() {
      if (this.ready) {
        this.scheduleRowUpdate.cancel();
        this.scheduleRowUpdate();
      }
    },

    updateScrollStatus: debounce(function () {
      this.$table.scrollStore.scrollActive = false;
      const currentlyHoveredRow = this.$el.querySelector('.pendo-table__row:hover');

      if (!currentlyHoveredRow) {
        return;
      }

      const index = currentlyHoveredRow.getAttribute('data-uid');
      const hoveredRow = this.$table.tableData[index];
      this.$table.setRowHover(hoveredRow, index);
    }, 200, {
      leading: false,
      trailing: true
    }),

    handleScroll(event) {
      const isPageMode = this.$table.scrollStore.pageMode;
      const scrollLeft = isPageMode ? this.$el.scrollLeft : event.target.scrollLeft;

      if (this.$table.overflowX && this.$table.scrollStore.scrollLeft !== scrollLeft) {
        this.syncScrollPositions(isPageMode ? this.$el : event.target);
      }

      if (this.$table.scrollStore.enabled) {
        if (this.$table.scrollStore.scrollTop !== event.target.scrollTop) {
          this.scheduleRowUpdate.cancel();
          this.scheduleRowUpdate();
        }

        this.$table.clearRowHover();
        this.$table.scrollStore.scrollActive = true;
        this.updateScrollStatus();
      }
    },

    syncScrollPositions({
      clientWidth,
      scrollWidth,
      scrollLeft
    }) {
      this.$table.scrollLeftToRight = scrollLeft > 0;
      this.$table.scrollRightToLeft = clientWidth < scrollWidth - scrollLeft;
      this.$table.$refs.tableHeader.$el.scrollLeft = scrollLeft;
      this.$table.scrollStore.scrollLeft = scrollLeft;
    },

    computeStartAndEndIndexes(scroll, buffer, tableDataLength, rowHeight, tableDataHeightMap) {
      scroll.start -= buffer;
      scroll.end += buffer;

      if (rowHeight) {
        const startIndex = Math.max(Math.floor(scroll.start / rowHeight), 0);
        const endIndex = Math.min(Math.ceil(scroll.end / rowHeight), tableDataLength);
        return [startIndex, endIndex];
      }

      const startIndex = Math.max(0, tableDataHeightMap.findIndex(heightAtIndex => heightAtIndex > scroll.start) - 1);
      let stopIndex = tableDataHeightMap.length;

      for (let i = startIndex; i < tableDataHeightMap.length; i++) {
        const heightAtIndex = tableDataHeightMap[i];

        if (heightAtIndex > scroll.end) {
          stopIndex = i;
          break;
        }
      }

      return [startIndex, stopIndex];
    },

    updateVisibleRows() {
      let startIndex = 0;
      let endIndex = 0;
      let row;
      let data;
      const _this$$table = this.$table,
            tableData = _this$$table.tableData,
            tableDataHeightMap = _this$$table.tableDataHeightMap,
            scrollStore = _this$$table.scrollStore,
            tableRows = _this$$table.tableRows;
      const rowHeight = scrollStore.rowHeight,
            buffer = scrollStore.buffer,
            enabled = scrollStore.enabled;
      const count = tableData.length;
      const scroll = this.getScroll();

      if (count && enabled) {
        var _this$computeStartAnd = this.computeStartAndEndIndexes(scroll, buffer, count, rowHeight, tableDataHeightMap);

        var _this$computeStartAnd2 = _slicedToArray(_this$computeStartAnd, 2);

        startIndex = _this$computeStartAnd2[0];
        endIndex = _this$computeStartAnd2[1];
      } else {
        startIndex = 0;
        endIndex = count;
      }

      for (let r = 0, i = startIndex; i < endIndex; r++, i++) {
        data = tableData[i];

        if (tableRows[r]) {
          row = tableRows[r];
          row.nr.index = i;
          row.data = data;
        } else {
          row = {
            data
          };
          const nonReactive = {
            id: uid++,
            index: i
          };
          Object.defineProperty(row, 'nr', {
            configurable: false,
            value: nonReactive
          });
          tableRows.push(row);
        }
      }

      if (tableRows.length + startIndex > count) {
        tableRows.length = Math.max(count - startIndex, 0);
      }

      if (tableRows.length > endIndex - startIndex) {
        tableRows.length = endIndex - startIndex;
      }

      if (rowHeight) {
        this.$table.scrollStore.scrollTop = Math.floor(startIndex * rowHeight);
      } else {
        this.$table.scrollStore.scrollTop = tableDataHeightMap[startIndex];
      }

      this.$table.calculateStickyElementPositions();
    }

  }
};

const __vue_script__$8 = script$8;

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__body",
    class: {
      'pendo-table__body--page-mode': _vm.$table.scrollStore.pageMode
    },
    style: _vm.$table.bodyStyle,
    on: {
      "&scroll": function ($event) {
        return _vm.handleScroll($event);
      },
      "mouseleave": function ($event) {
        return _vm.$table.clearRowHover();
      }
    }
  }, [_c('div', {
    style: {
      width: '0px',
      float: 'left',
      height: _vm.$table.scrollStore.scrollHeight + "px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-table__scroll-container",
    style: {
      transform: "translate3d(0px, " + _vm.$table.scrollStore.scrollTop + "px, 0px)"
    }
  }, [_c('table', {
    style: {
      width: _vm.$table.bodyWidth === null ? _vm.$table.bodyWidth : _vm.$table.bodyWidth + "px"
    },
    attrs: {
      "aria-rowcount": _vm.$table.rowsMap.size,
      "aria-colcount": _vm.$table.tableColumns.length,
      "role": "grid",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', _vm._l(_vm.$table.tableColumns, function (column, columnIndex) {
    return _c('col', {
      key: columnIndex,
      attrs: {
        "name": column.id,
        "width": column.renderWidth
      }
    });
  }), 0), _vm._v(" "), _c('tbody', [_vm._l(_vm.$table.tableRows, function (row) {
    return [_c('table-row', {
      key: row.nr.id,
      attrs: {
        "row": row.data,
        "data-uid": row.nr.index,
        "index": row.nr.index
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (ref) {
          var naturalIndex = ref.naturalIndex;
          var rowIndex = ref.rowIndex;
          return [!row.data.isGroup ? _vm._l(_vm.$table.tableColumns, function (column, columnIndex) {
            return _c('table-cell', {
              key: column.columnKey,
              attrs: {
                "column": column,
                "column-index": columnIndex,
                "natural-index": naturalIndex,
                "row": row.data,
                "row-index": rowIndex,
                "row-level": 0
              }
            });
          }) : _vm._e(), _vm._v(" "), row.data.isGroup ? _c('td', {
            staticClass: "pendo-table__column",
            style: {
              height: row.data.height + "px"
            },
            attrs: {
              "colspan": _vm.$table.tableColumns.length
            }
          }, [_c('table-slot', {
            attrs: {
              "name": "groupRow",
              "row": row.data,
              "row-index": rowIndex
            }
          })], 1) : _vm._e()];
        }
      }], null, true)
    }), _vm._v(" "), _vm.$table.expandedMap[row.data[_vm.$table.rowKey]] ? _c('table-row', {
      key: "expand_" + row.nr.index,
      staticClass: "pendo-table__row--expand",
      attrs: {
        "row": row.data,
        "index": row.nr.index
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (ref) {
          var rowIndex = ref.rowIndex;
          return [_c('td', {
            staticClass: "pendo-table__column",
            class: {
              'pendo-table__column--fixed-left': _vm.$table.tableColumns[0].fixed === 'left' && _vm.$table.overflowX,
              'is-fixed-left': _vm.$table.tableColumns[0].fixed === 'left' && _vm.$table.overflowX && _vm.$table.scrollLeftToRight
            }
          }), _vm._v(" "), _c('td', {
            staticClass: "pendo-table__column",
            attrs: {
              "colspan": _vm.$table.tableColumns.length - 1
            }
          }, [_c('table-slot', {
            attrs: {
              "name": "expandContent",
              "row": row.data,
              "row-index": rowIndex
            }
          })], 1)];
        }
      }], null, true)
    }) : _vm._e()];
  })], 2), _vm._v(" "), _vm._t("append"), _vm._v(" "), _c('ResizeObserver', {
    on: {
      "notify": _vm.handleResize
    }
  })], 2)]), _vm._v(" "), !_vm.$table.loading && !_vm.$table.tableData.length ? _c('div', {
    staticClass: "pendo-table__empty-block"
  }, [_c('span', {
    staticClass: "pendo-table__empty-text"
  }, [_vm._t("empty", [_vm._v("\n                " + _vm._s(_vm.$table.emptyText) + "\n            ")])], 2)]) : _vm._e(), _vm._v(" "), _vm.$table.loading && !_vm.$table.tableData.length ? _c('pendo-responsive', {
    attrs: {
      "max-height": _vm.$table.bodyStyle.maxHeight,
      "height": _vm.$table.bodyStyle.height,
      "aspect-ratio": 16 / 9
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$7 = [];
const __vue_inject_styles__$8 = undefined;
const __vue_scope_id__$8 = undefined;
const __vue_is_functional_template__$8 = false;

function __vue_normalize__$8(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "table-body.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var TableBody = __vue_normalize__$8({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8);

const csvDelimiter = ',';
const csvNewLine = '\r\n';

function formatCSVField(value) {
  let fixedValue = value;
  const addQuotes = value.indexOf(csvDelimiter) !== -1 || value.indexOf('\r') !== -1 || value.indexOf('\n') !== -1;
  const replaceDoubleQuotes = value.indexOf('"') !== -1;
  const addHorizontalTab = value.indexOf('=') === 0 || value.indexOf('+') === 0 || value.indexOf('-') === 0 || value.indexOf('@') === 0;

  if (replaceDoubleQuotes) {
    fixedValue = fixedValue.replace(/"/g, '""');
  }

  if (addHorizontalTab) {
    fixedValue = `\t${fixedValue}`;
  }

  if (addQuotes || replaceDoubleQuotes || addHorizontalTab) {
    fixedValue = `"${fixedValue}"`;
  }

  return fixedValue;
}

function tableToCSV(tableColumns, tableData) {
  let data = '';
  let i, c, row, col;

  for (i = 0; i < tableData.length; i++) {
    row = tableData[i];

    for (c = 0; c < tableColumns.length; c++) {
      let rowValue;
      col = tableColumns[c];

      if (col.formatter) {
        rowValue = col.formatter(row, col);
      } else {
        rowValue = getProp(row, col.property);
      }

      if (rowValue == null) {
        rowValue = '';
      }

      data = data + (c ? csvDelimiter : '') + formatCSVField(String(rowValue).trim());
    }

    data += csvNewLine;
  }

  return data;
}
function downloadCSV({
  csvData,
  filename
}) {
  if (window.navigator.msSaveBlob && window.Blob) {
    window.navigator.msSaveBlob(new Blob([csvData], {
      type: 'text/csv'
    }), filename);
    return;
  }

  const anchor = document.createElement('a');
  anchor.target = '_blank';
  anchor.download = filename;

  if (window.Blob && window.URL && window.URL.createObjectURL) {
    anchor.href = window.URL.createObjectURL(new Blob([csvData], {
      type: 'text/csv'
    }));
  } else {
    anchor.href = `data:attachment/csv;charset=utf-8,${encodeURIComponent(csvData)}`;
  }

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
function getCSVColumns(vm) {
  const columns = get(vm.csvConfig, 'columns', vm.tableColumns);
  return cloneDeep(columns).map(column => getColumnConfig(column)).filter(column => column.property && column.downloadable);
}
function getCSVFilename(vm) {
  const defaultFilename = `${kebabCase(vm.tableTitle)}-${new Date().getTime()}.csv`;
  const filename = get(vm.csvConfig, 'filename', vm.csvFilename) || defaultFilename;

  if (!filename.endsWith('.csv')) {
    return `${filename}.csv`;
  }

  return filename;
}

const collator = new Intl.Collator('en', {
  numeric: true,
  sensitivity: 'base'
});
function compareBooleans(a, b) {
  return a === b ? 0 : a ? -1 : 1;
}
function compare(a, b, column) {
  let aValue;
  let bValue;

  if (column.sortBy) {
    aValue = column.sortBy(a);
    bValue = column.sortBy(b);
  } else if (column.formatter) {
    if (new Date(getProp(a, column.property)).getTime()) {
      aValue = getProp(a, column.property);
      bValue = getProp(b, column.property);
    } else {
      aValue = column.formatter(a, column);
      bValue = column.formatter(b, column);
    }
  } else {
    aValue = getProp(a, column.property);
    bValue = getProp(b, column.property);
  }

  let result = 0;

  if (Boolean(aValue) === aValue && Boolean(bValue) === bValue) {
    result = compareBooleans(aValue, bValue);
  } else {
    result = collator.compare(aValue, bValue);
  }

  if (column.order === 'ascending') {
    return result;
  }

  return -result;
}

function createCompareFunction(column) {
  if (column.sortMethod) {
    return column.sortMethod;
  }

  return (a, b) => compare(a, b, column);
}

function sortRow(row, compareFunction, parents = [], options) {
  if (options && options.sortChildren && Array.isArray(row[options.childKey])) {
    const childRows = [...row[options.childKey]].sort((a, b) => compareFunction(a, b, [...parents, row])).map(childRow => sortRow(childRow, compareFunction, [...parents, row, childRow], options));
    return _objectSpread({}, row, {
      [options.childKey]: childRows
    });
  }

  return row;
}

function sortRows({
  rows,
  sortConfig,
  options
}) {
  if (sortConfig.column) {
    if (sortConfig.column.order === 'none') {
      return [...rows];
    }

    const compareFunction = createCompareFunction(sortConfig.column);

    if (options.groupKey) {
      return rows.map(row => sortRow(row, compareFunction, [], options));
    }

    return rows.sort((a, b) => compareFunction(a, b)).map(row => sortRow(row, compareFunction, [], options));
  }

  return rows;
}

function filterCell(cellValue, {
  value,
  type
}) {
  if (cellValue == null) {
    return false;
  }

  if (!Array.isArray(value)) {
    value = [value];
  }

  if (type === 'exact') {
    return value.some(val => normalizeValue(cellValue) === normalizeValue(val));
  }

  return value.some(val => normalizeValue(cellValue).includes(normalizeValue(val)));
}
function createFilterFunction(props, columns) {
  if (!Array.isArray(props)) {
    props = [props];
  }

  return (row, filter) => {
    return props.some(prop => {
      const column = columns.find(column => column.property === prop);
      let cellValue = getProp(row, prop);

      if (column && column.formatter) {
        cellValue = column.formatter(row, column);
      }

      if (isPlainObject(cellValue)) {
        console.warn(`filtering entire objects is not supported. Please update filter prop ${prop} to reference a specific key in the object.`);
      }

      return filterCell(cellValue, filter);
    });
  };
}
function buildPerColumnFilters(columns) {
  return columns.reduce((acc, column) => {
    if (column.filters && column.filters.length) {
      const filter = {
        prop: column.property,
        value: []
      };
      column.filters.forEach(({
        checked,
        value
      }) => {
        if (checked) {
          filter.value.push(value);
        }
      });

      if (filter.value.length) {
        if (isFunction(column.filterMethod)) {
          filter.filterFn = column.filterMethod;
        }

        acc.push(filter);
      }
    }

    return acc;
  }, []);
}
function applyFilterToRows(rows, filterFunction, filter, options) {
  const filterRow = (result, row) => {
    if (!row.isGroup && filterFunction(row, filter)) {
      result.push(row);
      return result;
    }

    if (options && Array.isArray(row[options.childKey])) {
      const childRows = row[options.childKey].reduce(filterRow, []);

      if (childRows.length) {
        result.push(_objectSpread({}, row, {
          [options.childKey]: childRows
        }));
      }
    }

    return result;
  };

  return rows.reduce(filterRow, []);
}
function filterRows({
  rows,
  columns,
  globalFilters,
  options
}) {
  const filters = [...globalFilters, ...buildPerColumnFilters(columns)];

  if (filters.length > 0) {
    filters.forEach(filter => {
      const value = filter.value,
            filterFn = filter.filterFn;
      const emptyArray = Array.isArray(value) && value.length === 0;
      const noValue = value === undefined || value === '';

      if (emptyArray || noValue && !filterFn) {
        return true;
      }

      const filterFunction = filterFn || createFilterFunction(filter.prop, columns);
      rows = applyFilterToRows(rows, filterFunction, filter, options);
    });
  }

  return rows;
}

function groupRows({
  rows,
  options
}) {
  const groupedRows = groupBy(rows, options.groupKey);
  return Object.keys(groupedRows).map(groupKey => {
    return {
      [options.rowKey]: uuid(),
      [options.groupKey]: groupKey,
      [options.childKey]: groupedRows[groupKey],
      height: options.groupRowHeight || 32,
      isGroup: true
    };
  });
}

var script$9 = {
  name: 'PendoTable',
  components: {
    CollapseTransition,
    PendoColumnChooser,
    TableTitle,
    TableHeader,
    TableBody
  },
  directives: {
    ObserveVisibility,
    PendoLoading: PendoLoading$1,
    PendoTooltip
  },

  provide() {
    return {
      $table: this
    };
  },

  inheritAttrs: false,
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: [Number, String],
      default: null
    },
    maxHeight: {
      type: [Number, String],
      default: null
    },
    resizable: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    condensed: {
      type: Boolean,
      default: false
    },
    fit: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false
    },
    highlightHoverRow: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      type: [String, Function],
      default: null
    },
    cellClassName: {
      type: [String, Function],
      default: null
    },
    headerRowClassName: {
      type: [String, Function],
      default: null
    },
    headerCellClassName: {
      type: [String, Function],
      default: null
    },
    showAllOverflow: {
      type: [Boolean, String],
      default: null
    },
    rowKey: {
      type: [String, Number],
      default: 'id'
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    autoHeightOffset: {
      type: Number,
      default: 82
    },
    treeConfig: {
      type: Object,
      default: null
    },
    groupConfig: {
      type: Object,
      default: null
    },
    checkboxConfig: {
      type: Object,
      default: () => ({})
    },
    emptyText: {
      type: String,
      default: 'No Data Found.'
    },
    defaultSort: {
      type: Object,
      default: null
    },
    filters: {
      type: [Object, Array],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    borderless: {
      type: Boolean,
      default: false
    },
    csvDownload: {
      type: [Boolean, Function],
      default: false
    },
    csvFilename: {
      type: String,
      default: null
    },
    csvConfig: {
      type: Object,
      default: null
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    manageColumns: {
      type: Boolean,
      default: false
    },
    scrollConfig: {
      type: Object,

      default() {
        return {
          enabled: true,
          rowHeight: this.condensed ? 40 : 56,
          buffer: 300
        };
      }

    },
    headerProps: {
      type: Object,
      default: null
    },
    tableProps: {
      type: Object,
      default: null
    },
    manageColumnsConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      activeRow: null,
      allTableColumns: [],
      bodyStyle: {},
      bodyWidth: 0,
      collapsed: false,
      collapseTooltipContent: 'Collapse',
      expandedMap: {},
      filterStore: {
        column: null,
        isAllSelected: false,
        isIndeterminate: false,
        multiple: false,
        options: [],
        visible: false
      },
      horizontalScrollbarHeight: 0,
      hoverColumnHeader: null,
      hoverRow: null,
      id: `pendo-table-${uniqueId()}`,
      isAllSelected: false,
      isAllTreeExpanded: false,
      isIndeterminate: false,
      manageColumnStore: {
        visible: false
      },
      overflowX: false,
      underflowX: false,
      overflowY: false,
      ready: false,
      scrollLeftToRight: false,
      scrollRightToLeft: false,
      scrollStore: {
        buffer: 300,
        enabled: true,
        endIndex: 0,
        position: 0,
        rowHeight: 56,
        scrollActive: false,
        scrollHeight: 0,
        scrollLeft: 0,
        scrollTop: 0,
        startIndex: 0,
        pageMode: false,
        stickyElementPositions: {
          title: 0,
          header: 0,
          filters: 0
        }
      },
      selectedMap: {},
      selectRow: null,
      sortStore: {
        activeSort: null,
        column: null
      },
      tableColumns: [],
      tableData: [],
      tableDataHeightMap: [],
      tableRows: [],
      tableStyle: {},
      treeExpandedMap: {},
      treeExpandedChildMap: {},
      verticalScrollbarWidth: 0
    };
  },

  computed: {
    showTableStatusSlot() {
      return hasSlot(this, 'status');
    },

    showTableTitle() {
      return Boolean(this.tableTitle || hasSlot(this, 'header') || hasSlot(this, 'headerLeft') || hasSlot(this, 'headerRight') || hasSlot(this, 'headerActions'));
    },

    tableTitle() {
      if (this.headerProps && this.headerProps.title) {
        return this.headerProps.title;
      }

      return this.title;
    },

    tableHeight() {
      if (this.tableProps && this.tableProps.height) {
        return this.tableProps.height;
      }

      return this.height;
    },

    tableMaxHeight() {
      if (this.tableProps && this.tableProps.maxHeight) {
        return this.tableProps.maxHeight;
      }

      return this.maxHeight;
    },

    tableDefaultSort() {
      if (this.tableProps && this.tableProps.defaultSort) {
        return this.tableProps.defaultSort;
      }

      return this.defaultSort;
    },

    tableAutoHeight() {
      if (this.tableProps && this.tableProps.autoHeight) {
        return this.tableProps.autoHeight;
      }

      return this.autoHeight;
    },

    tableAutoHeightOffset() {
      if (this.tableProps && this.tableProps.autoHeightOffset) {
        return this.tableProps.autoHeightOffset;
      }

      return this.autoHeightOffset || 0;
    }

  },
  watch: {
    data(value) {
      this.reloadData(value || [], false);
    },

    filters: {
      handler() {
        this.clearSelected();
        this.updateActiveTableData();
      },

      deep: true
    },

    columns(value) {
      this.reloadColumns(value);
    },

    groupConfig: {
      handler() {
        this.clearSelected();
        this.updateActiveTableData();
      },

      deep: true
    },

    tableDefaultSort() {
      this.handleDefaultSort();
    },

    status: 'updateTableHeight'
  },

  created() {
    Object.assign(this.scrollStore, this.scrollConfig, {
      startIndex: 0,
      scrollHeight: 0
    });
    this.rowsMap = new Map();
    this.columnsMap = new Map();
    this.tableRows = [];
    this.loadColumns(this.columns);
    this.loadData(this.data);

    if (this.tableDefaultSort) {
      this.handleDefaultSort();
    }

    this.resizeObserver = new ResizeObserver$1(this.handleResizeEvent);
  },

  async mounted() {
    this.refreshLayout();
    await this.$nextTick();
    this.ready = true;
    this.addResizeObservers();
    this.calculateStickyElementPositions();
  },

  beforeDestroy() {
    this.hideFilterPanel();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  methods: {
    calculateStickyElementPositions() {
      if (!this.scrollStore.pageMode) {
        return;
      }

      const filterBar = document.querySelector('.pendo-filter-bar');
      let offset = 0;

      if (filterBar) {
        const filterBarPosInScrollTarget = elementPositionInAncestor(filterBar, ScrollParent(this.$el));
        const filterBarContentRect = filterBar.getBoundingClientRect();
        const filterBarScrollContainerOffset = filterBarContentRect.top - filterBarPosInScrollTarget.top;
        offset += filterBar.offsetHeight + filterBarScrollContainerOffset;
      }

      this.scrollStore.stickyElementPositions.title = offset;
      const title = this.$el.querySelector('.pendo-table__title');

      if (title) {
        offset += title.offsetHeight;
      }

      this.scrollStore.stickyElementPositions.filters = offset;
      const filters = this.$el.querySelector('.pendo-table__filters');

      if (filters) {
        offset += filters.offsetHeight;
      }

      this.scrollStore.stickyElementPositions.header = offset;
    },

    addResizeObservers() {
      if (this.$el) {
        this.resizeObserver.observe(this.$el);
      }

      if (this.tableAutoHeight) {
        const scrollParent = getScrollParent(this.$el);

        if (scrollParent) {
          this.resizeObserver.observe(scrollParent);
        }
      }
    },

    getDeprecationConfig() {
      return {
        props: {
          tableProps: 'tableProps has been removed. Pass props directly on component.',
          headerProps: 'headerProps has been removed. Pass title on component.',
          csvFilename: 'pass csvFilename using csvConfig.filename'
        }
      };
    },

    clearFilter() {
      this.filterStore = {
        isAllSelected: false,
        isIndeterminate: false,
        options: [],
        column: null,
        multiple: false,
        visible: false
      };
      return this.$nextTick();
    },

    clearSelected() {
      this.isAllSelected = false;
      this.isIndeterminate = false;
      this.selectedMap = {};
      emitEvent(this, 'select-clear', [{
        selectedRows: []
      }]);
      return this.$nextTick();
    },

    clearCurrentRow() {
      this.selectRow = null;
      this.hoverRow = null;
      this.hoverColumnHeader = null;
      return this.$nextTick();
    },

    clearRowExpand() {
      this.expandedMap = {};
      return this.$nextTick();
    },

    clearScroll() {
      this.scrollStore = _objectSpread({}, this.scrollStore, {
        startIndex: 0,
        scrollTop: 0
      });
      const tableBody = this.$refs.tableBody;

      if (tableBody && tableBody.$el) {
        tableBody.$el.scrollTop = 0;
        tableBody.$el.scrollLeft = 0;
      }

      return this.$nextTick();
    },

    clearTreeExpand() {
      this.treeExpandedMap = {};
      this.treeExpandedChildMap = {};
      return this.$nextTick();
    },

    clearAll(clearScroll) {
      this.clearFilter();
      this.clearRowExpand();

      if (clearScroll) {
        this.clearScroll();
      }

      if (!this.checkboxConfig.reserve) {
        this.clearSelected();
      }

      this.clearTreeExpand();
    },

    loadColumns(columns) {
      if (!columns) {
        return this.$nextTick();
      }

      const tableColumns = cloneDeep(columns).map(column => getColumnConfig(column));
      const actionsColumn = tableColumns.findIndex(column => column.type === 'actions');

      if (actionsColumn) {
        tableColumns.push(...tableColumns.splice(actionsColumn, 1));
      }

      if (this.manageColumns) {
        this.allTableColumns = tableColumns;
        this.tableColumns = tableColumns.filter(column => column && column.visible);
      } else {
        this.tableColumns = tableColumns;
      }

      this.columnsMap.clear();
      let key;
      this.tableColumns.forEach(column => {
        key = column.columnKey;
        this.columnsMap.set(key, column);
      });
      return this.$nextTick();
    },

    async loadData(data) {
      if (!data) {
        return this.$nextTick();
      }

      const rowKey = this.rowKey;
      this.rowsMap.clear();
      data.forEach(row => {
        if (!row[rowKey]) {
          warn(`One or more rows does not have the supplied 'rowKey' prop of '${rowKey}'. Each row must have a unique '${rowKey}' key. If the row does not have that key, consider changing the 'rowKey' prop to another unique key the row does have.`, this);
          return;
        }

        this.rowsMap.set(row[rowKey], row);
      });
      await this.updateActiveTableData();
      return this.$nextTick();
    },

    async reloadColumns(columns) {
      this.clearAll();
      await this.loadColumns(columns);

      if (this.sortStore.column) {
        const sortedColumn = this.tableColumns.find(column => column.property === this.sortStore.column.property);

        if (sortedColumn) {
          this.setActiveSort(this.sortStore.column.property, this.sortStore.activeSort);
        } else if (this.tableDefaultSort) {
          this.handleDefaultSort();
        }
      }

      if (!this.sortStore.activeSort && this.tableDefaultSort) {
        this.handleDefaultSort();
      }

      this.updateActiveTableData();
      this.refreshLayout();
    },

    async reloadData(data, clearScroll) {
      this.clearAll(clearScroll);
      await this.loadData(data);

      if (this.checkboxConfig.reserve && this.getSelectedRows().length) {
        this.updateSelectedRows(this.getSelectedRows());
      }
    },

    updateSelectionStatus() {
      const selectedRows = this.getSelectedRows();

      if (!selectedRows.length) {
        this.isAllSelected = false;
        this.isIndeterminate = false;
        return;
      }

      const totalSelectableRows = this.tableData.filter(row => {
        if (this.checkboxConfig.checkMethod) {
          return this.checkboxConfig.checkMethod(row);
        }

        return true;
      });
      this.isAllSelected = selectedRows.length === totalSelectableRows.length;
      this.isIndeterminate = !this.isAllSelected && this.tableData.some(row => this.selectedMap[row[this.rowKey]]);
    },

    updateActiveTableData() {
      const rowKey = this.rowKey,
            tableColumns = this.tableColumns,
            rowsMap = this.rowsMap,
            filters = this.filters,
            sortStore = this.sortStore,
            treeConfig = this.treeConfig,
            groupConfig = this.groupConfig;
      let tableData = [...rowsMap.values()];
      const options = {};
      const isRowGroupingEnabled = groupConfig && groupConfig.enabled;
      const isRowTreeEnabled = treeConfig && treeConfig.children;

      if (isRowGroupingEnabled) {
        options.childKey = 'children';
        options.sortChildren = groupConfig.sortChildren;
        options.rowKey = rowKey;
        options.groupKey = groupConfig.groupKey;
        options.groupRowHeight = groupConfig.groupRowHeight;

        options.childRowFilter = () => true;

        tableData = groupRows({
          rows: tableData,
          options
        });
      }

      if (isRowTreeEnabled) {
        options.childKey = treeConfig.children;
        options.sortChildren = treeConfig.sortChildren;

        options.childRowFilter = row => this.treeExpandedMap[row[rowKey]];
      }

      tableData = filterRows({
        rows: tableData,
        columns: tableColumns,
        globalFilters: filters || [],
        options
      });
      tableData = sortRows({
        rows: tableData,
        sortConfig: sortStore,
        options
      });

      if (isRowTreeEnabled || isRowGroupingEnabled) {
        tableData = flattenChildRows(tableData, options);
      }

      if (!this.scrollStore.rowHeight) {
        const tableDataHeightMap = [];
        let cummulativeHeight = 0;
        tableData.forEach(row => {
          tableDataHeightMap.push(cummulativeHeight);
          cummulativeHeight += row.height;
        });
        this.tableDataHeightMap = tableDataHeightMap;
      }

      this.tableData = tableData;
      emitEvent(this, 'table-data-change', [{
        data: tableData
      }]);
      this.updateScrollHeight();
    },

    updateSelectedRows(selectedRows) {
      const rowsMap = this.rowsMap,
            rowKey = this.rowKey;

      if (Array.isArray(selectedRows) && selectedRows.length) {
        const activeRows = selectedRows.filter(selected => rowsMap.has(selected[rowKey]));
        this.selectedMap = keyBy(activeRows, rowKey);
      } else {
        this.selectedMap = {};
      }

      this.updateSelectionStatus();
    },

    getSelectedRows() {
      return Object.values(this.selectedMap);
    },

    getExpandedRows() {
      return Object.values(this.expandedMap);
    },

    getTreeExpandedRows() {
      return Object.values(this.treeExpandedMap);
    },

    downloadTableData() {
      const columns = getCSVColumns(this);
      const filename = getCSVFilename(this);
      const isRowGroupingEnabled = this.groupConfig && this.groupConfig.enabled;
      const isRowTreeEnabled = this.treeConfig && this.treeConfig.children;
      let data = this.tableData;

      if (isRowGroupingEnabled) {
        data = data.filter(row => !row.isGroup);
      }

      if (isRowTreeEnabled) {
        data = flattenChildRows(data, {
          childKey: this.treeConfig.children,
          childRowFilter: row => {
            return !this.treeExpandedMap[row[this.rowKey]];
          }
        });
      }

      if (typeof this.csvDownload === 'function') {
        return this.csvDownload(columns, data);
      }

      const header = columns.map(column => column.label).join(',');
      const csvData = `\ufeff${header}\n${tableToCSV(columns, data)}`;
      return downloadCSV({
        csvData,
        filename
      });
    },

    handleVisibilityChange(isVisible) {
      if (this.ready && isVisible) {
        requestAnimationFrame(() => {
          this.refreshLayout();
        });
      }
    },

    handleResizeEvent(entries) {
      entries.forEach(entry => emitEvent(this, 'resize', [entry]));
      this.refreshLayout();
      this.calculateStickyElementPositions();
    },

    refreshLayout() {
      this.updateColumnsWidth();

      if (!this.collapsed) {
        this.updateTableHeight();
      }

      this.updateScrollHeight();
    },

    updateScrollHeight() {
      const scrollHeight = this.tableData.reduce((acc, row) => {
        acc += row.height || this.scrollStore.rowHeight;
        return acc;
      }, 0);

      if (scrollHeight !== this.scrollStore.scrollHeight) {
        this.scrollStore.scrollHeight = scrollHeight;
        emitEvent(this, 'scroll-height-change', [{
          scrollHeight
        }]);
      }

      const tableBody = this.$refs.tableBody;

      if (!tableBody || !tableBody.$el) {
        return;
      }

      const overflowY = scrollHeight > tableBody.$el.clientHeight;

      if (overflowY !== this.overflowY) {
        this.overflowY = overflowY;
        emitEvent(this, 'overflow-y-change', [{
          overflowY
        }]);
      }

      return this.$nextTick();
    },

    updateColumnsWidth() {
      const fit = this.fit,
            columnsMap = this.columnsMap;
      const tableBody = this.$refs.tableBody;

      if (!tableBody || !tableBody.$el) {
        return;
      }

      const bodyElem = tableBody.$el;
      const bodyWidth = bodyElem.clientWidth;
      let totalColumnsWidth = 0;
      let flexColumnsWidth = 0;
      let remainingWidth = bodyWidth;
      const cellMinWidth = 36;
      const fixedRightColumns = [];
      const fixedLeftColumns = [];
      const flexWidthColumns = [];
      columnsMap.forEach((column, key) => {
        switch (column.widthType) {
          case 'fixed':
            const width = parseInt(column.width, 10);
            totalColumnsWidth += width;
            column.renderWidth = width;
            break;

          case 'flex':
            const minWidth = parseInt(column.minWidth, 10);
            flexColumnsWidth += minWidth;
            totalColumnsWidth += minWidth;
            column.renderWidth = minWidth;
            flexWidthColumns.push(column);
            break;

          case 'resize':
            const resizeWidth = parseInt(column.resizeWidth, 10);
            totalColumnsWidth += resizeWidth;
            column.renderWidth = resizeWidth;
            break;
        }

        switch (column.fixed) {
          case 'left':
            fixedLeftColumns.push(column);
            break;

          case 'right':
            fixedRightColumns.push(column);
            break;
        }

        columnsMap.set(key, column);
      });
      remainingWidth -= totalColumnsWidth;

      if (flexWidthColumns.length > 0 && fit) {
        const verticalScrollbarWidth = this.overflowY ? getScrollbarWidth() : 0;
        this.verticalScrollbarWidth = verticalScrollbarWidth;

        if (remainingWidth > verticalScrollbarWidth) {
          this.overflowX = false;
          this.scrollLeftToRight = false;
          this.scrollRightToLeft = false;
          const totalFlexWidth = remainingWidth - verticalScrollbarWidth;

          if (flexWidthColumns.length === 1) {
            const column = flexWidthColumns[0];
            column.renderWidth = (column.minWidth || cellMinWidth) + totalFlexWidth;
            columnsMap.set(column.columnKey, column);
          } else {
            const flexWidthPerPixel = totalFlexWidth / flexColumnsWidth;
            let noneFirstWidth = 0;
            flexWidthColumns.forEach((column, index) => {
              if (index === 0) {
                return;
              }

              const flexWidth = Math.floor((column.minWidth || cellMinWidth) * flexWidthPerPixel);
              noneFirstWidth += flexWidth;
              column.renderWidth = (column.minWidth || cellMinWidth) + flexWidth;
              columnsMap.set(column.columnKey, column);
            });
            const column = flexWidthColumns[0];
            column.renderWidth = (column.minWidth || cellMinWidth) + totalFlexWidth - noneFirstWidth;
            columnsMap.set(column.columnKey, column);
          }
        } else {
          this.overflowX = true;
          flexWidthColumns.forEach(column => {
            column.renderWidth = column.minWidth;
            columnsMap.set(column.columnKey, column);
          });
        }

        this.bodyWidth = Math.max(totalColumnsWidth, bodyWidth);
      } else {
        this.overflowX = totalColumnsWidth > bodyWidth;
        this.bodyWidth = totalColumnsWidth;
      }

      if (this.overflowX) {
        this.underflowX = false;
        this.scrollLeftToRight = bodyElem.scrollLeft > 0;
        this.scrollRightToLeft = bodyElem.clientWidth < bodyElem.scrollWidth - bodyElem.scrollLeft;
      } else {
        let totalColWidth = 0;
        columnsMap.forEach(column => {
          totalColWidth += column.renderWidth;
        });
        this.underflowX = totalColWidth < bodyWidth;
        this.scrollStore.scrollLeft = 0;
      }

      if (fixedLeftColumns.length > 0) {
        fixedLeftColumns.reduce((fixedPositionLeft, column, index) => {
          column.disableReorder = true;

          if (index === fixedLeftColumns.length - 1) {
            column.fixedShadow = true;
          }

          column.fixedPos = fixedPositionLeft;
          columnsMap.set(column.columnKey, column);
          return fixedPositionLeft + column.renderWidth;
        }, 0);
      }

      if (fixedRightColumns.length > 0) {
        fixedRightColumns.reduceRight((fixedPositionRight, column, index) => {
          if (index === fixedRightColumns.length - 1) {
            return fixedPositionRight + column.renderWidth;
          }

          if (index === 0) {
            column.fixedShadow = true;
          }

          column.fixedPos = fixedPositionRight;
          columnsMap.set(column.columnKey, column);
          return fixedPositionRight + column.renderWidth;
        }, 0);
      }

      const updatedColumns = [...columnsMap.values()];

      if (isEqual(this.tableColumns, updatedColumns)) {
        return this.$nextTick();
      }

      this.tableColumns = updatedColumns;
      return this.$nextTick();
    },

    showManageColumnsModal() {
      const usedIndices = [];
      const columns = [];
      this.allTableColumns.forEach((column, index) => {
        if (column.allowReorder && column.visible) {
          usedIndices.push(index);
          columns.push(column);
        }
      });
      const availableColumns = this.allTableColumns.filter(column => column.allowReorder);
      this.manageColumnStore = {
        columns,
        availableColumns,
        usedIndices,
        visible: true
      };
    },

    hideManageColumnsModal(columns) {
      const usedIndices = this.manageColumnStore.usedIndices;
      const allTableColumns = cloneDeep(this.allTableColumns);
      allTableColumns.forEach(column => {
        if (column.allowReorder && column.visible) {
          column.visible = false;
        }
      });
      columns.forEach((column, index) => {
        const newIndex = usedIndices[index];
        const oldIndex = allTableColumns.findIndex(col => col.property === column.property);
        allTableColumns[oldIndex].visible = true;

        if (newIndex == null) {
          allTableColumns.push(...allTableColumns.splice(oldIndex, 1));
        } else {
          allTableColumns.splice(newIndex, 0, ...allTableColumns.splice(oldIndex, 1));
        }
      });

      if (isEqual(this.allTableColumns, allTableColumns)) {
        return this.$nextTick();
      }

      this.reloadColumns(allTableColumns);
      const visibleColumns = this.tableColumns.reduce((columns, column) => {
        if (column.property) {
          columns.push(column.property);
        }

        return columns;
      }, []);
      emitEvent(this, 'column-change', [{
        columns: visibleColumns
      }]);
      return this.$nextTick();
    },

    collapseTable() {
      requestAnimationFrame(() => {
        this.collapsed = true;
        this.collapseTooltipContent = 'Expand';
        emitEvent(this, 'collapse-change', [{
          collapsed: this.collapsed
        }]);
      });
    },

    expandTable() {
      requestAnimationFrame(() => {
        this.collapsed = false;
        this.collapseTooltipContent = 'Collapse';
        emitEvent(this, 'collapse-change', [{
          collapsed: this.collapsed
        }]);
      });
    },

    toggleTableCollapse() {
      this.collapseTooltipContent = null;

      if (this.collapsed) {
        return this.expandTable();
      }

      this.collapseTable();
    },

    toggleColumnHeaderHover(column, colIndex) {
      if (!colIndex && colIndex !== 0) {
        this.hoverColumnHeader = null;
        return;
      }

      if (!column.sortable && !column.filters.length) {
        return;
      }

      requestAnimationFrame(() => {
        this.hoverColumnHeader = colIndex;
      });
    },

    toggleRowActive(row) {
      requestAnimationFrame(() => {
        this.activeRow = row[this.rowKey];
      });
    },

    clearRowHover() {
      const hoveredRows = this.$el.querySelectorAll('.pendo-table__row.is-hover');

      if (hoveredRows.length) {
        hoveredRows.forEach(elem => {
          removeClass(elem, 'is-hover');
        });
      }

      this.hoverRow = null;
    },

    setRowHover(row, index) {
      if (!this.highlightHoverRow || this.scrollStore.scrollActive || this.hoverRow === row[this.rowKey]) {
        return;
      }

      this.clearRowHover();
      addClass(this.$el.querySelector(`.pendo-table__row[data-uid="${index}"]`), 'is-hover');
      this.hoverRow = row[this.rowKey];
    },

    toggleAllRowsSelect(value) {
      if (value && this.checkboxConfig.selectAll !== false) {
        const selectableRows = this.tableData.filter(row => {
          if (this.checkboxConfig.checkMethod) {
            return this.checkboxConfig.checkMethod(row);
          }

          return true;
        });
        this.selectedMap = keyBy(selectableRows, this.rowKey);
        emitEvent(this, 'select-all', [{
          selectedRows: this.getSelectedRows()
        }]);
      } else {
        this.clearSelected();
      }

      this.updateSelectionStatus();
      emitEvent(this, 'select-change', [{
        selectedRows: this.getSelectedRows()
      }]);
    },

    toggleRowSelect({
      row
    }) {
      if (this.selectedMap[row[this.rowKey]]) {
        this.$delete(this.selectedMap, row[this.rowKey]);
        emitEvent(this, 'select-remove', [{
          row,
          checked: false
        }]);
      } else {
        this.$set(this.selectedMap, row[this.rowKey], row);
        emitEvent(this, 'select-add', [{
          row,
          checked: true
        }]);
      }

      this.updateSelectionStatus();
      emitEvent(this, 'select-change', [{
        row,
        selectedRows: this.getSelectedRows()
      }]);
    },

    toggleRowExpand(row) {
      row = this.rowsMap.get(row[this.rowKey]);

      if (this.expandedMap[row[this.rowKey]]) {
        this.$delete(this.expandedMap, row[this.rowKey]);
      } else {
        this.$set(this.expandedMap, row[this.rowKey], row);
      }

      emitEvent(this, 'expand-change', [{
        row,
        expandedRows: this.getExpandedRows()
      }]);
      this.updateActiveTableData();
      return this.$nextTick();
    },

    toggleRowTreeExpand(row) {
      row = this.rowsMap.get(row[this.rowKey]);

      if (this.treeExpandedMap[row[this.rowKey]]) {
        this.$delete(this.treeExpandedMap, row[this.rowKey]);
        row[this.treeConfig.children].forEach(childRow => {
          this.$delete(this.treeExpandedChildMap, childRow[this.rowKey]);
        });
      } else {
        this.$set(this.treeExpandedMap, row[this.rowKey], row);
        row[this.treeConfig.children].forEach(childRow => {
          this.$set(this.treeExpandedChildMap, childRow[this.rowKey], childRow);
        });
      }

      emitEvent(this, 'tree-expand-change', [{
        row,
        treeExpandedRows: this.getTreeExpandedRows()
      }]);
      this.updateActiveTableData();
      this.updateTreeExpandStatus();
      return this.$nextTick();
    },

    toggleAllRowsTreeExpand() {
      if (this.treeConfig.expandAll === false) {
        return;
      }

      if (!this.isAllTreeExpanded) {
        const treeExpandableRows = this.tableData.filter(row => row[this.treeConfig.children]);
        this.treeExpandedMap = keyBy(treeExpandableRows, this.rowKey);
        this.treeExpandedChildMap = treeExpandableRows.reduce((acc, row) => {
          row[this.treeConfig.children].forEach(childRow => {
            acc[childRow[this.rowKey]] = childRow;
          });
          return acc;
        }, {});
      } else {
        this.clearTreeExpand();
      }

      emitEvent(this, 'tree-expand-change', [{
        treeExpandedRows: this.getTreeExpandedRows()
      }]);
      this.updateActiveTableData();
      this.updateTreeExpandStatus();
      return this.$nextTick();
    },

    updateTreeExpandStatus() {
      const treeExpandedRows = this.getTreeExpandedRows();

      if (!treeExpandedRows.length) {
        this.isAllTreeExpanded = false;
        return;
      }

      const totalTreeExpandableRows = this.tableData.filter(row => row[this.treeConfig.children]);
      this.isAllTreeExpanded = treeExpandedRows.length === totalTreeExpandableRows.length;
    },

    handleCellClick(event, {
      cell,
      column,
      row
    }) {
      if (this.highlightCurrentRow) {
        requestAnimationFrame(() => {
          this.selectRow = row;
        });
      }

      emitEvent(this, 'cell-click', [{
        cell,
        column,
        event,
        row
      }]);
    },

    handleDefaultSort() {
      const _this$tableDefaultSor = this.tableDefaultSort,
            prop = _this$tableDefaultSor.prop,
            order = _this$tableDefaultSor.order;

      if (order === 'none') {
        return;
      }

      const sortedColumn = this.tableColumns.find(column => column.property === prop);

      if (!sortedColumn) {
        return;
      }

      const property = sortedColumn.property;
      const sortOrder = ['asc', 'ascending'].includes(order) ? 'ascending' : 'descending';
      this.setActiveSort(property, sortOrder);
    },

    setActiveSort(prop, order) {
      const tableColumns = this.tableColumns,
            sortStore = this.sortStore;
      const column = tableColumns.find(col => col.property === prop);

      if (sortStore.column && column.property !== sortStore.column.property) {
        this.sortStore = {
          column: null,
          activeSort: 'none'
        };
      }

      if (!order) {
        order = {
          none: 'ascending',
          ascending: 'descending',
          descending: 'none'
        }[this.sortStore.activeSort || 'none'];
      }

      if (this.sortStore.activeSort !== order) {
        this.sortStore = {
          column: _objectSpread({}, column, {
            order
          }),
          activeSort: order
        };

        if (column.sortable !== 'custom') {
          this.updateActiveTableData();
        }

        emitEvent(this, 'sort-change', [{
          column,
          prop,
          order
        }]);
      }

      return this.$nextTick();
    },

    filterColumn({
      value,
      column,
      optionIndex
    }) {
      this.filterStore.options[optionIndex].checked = value;
      this.updateActiveTableData();
      emitEvent(this, 'filter-change', [{
        column,
        prop: column.property,
        values: this.filterStore.options
      }]);
    },

    showFilterPanel(column) {
      const isAllSelected = column.filters.every(({
        checked
      }) => checked);
      const isIndeterminate = !isAllSelected && column.filters.some(({
        checked
      }) => checked);
      this.filterStore = {
        column,
        isAllSelected,
        isIndeterminate,
        multiple: column.filterMultiple,
        options: column.filters,
        visible: true
      };
    },

    hideFilterPanel() {
      this.filterStore = _objectSpread({}, this.filterStore, {
        isAllSelected: false,
        isIndeterminate: false,
        options: [],
        visible: false
      });
      return this.$nextTick();
    },

    updateTableHeight() {
      const _this$$refs = this.$refs,
            title = _this$$refs.title,
            filters = _this$$refs.filters,
            tableHeader = _this$$refs.tableHeader;
      let nonBodyHeight = 0;
      const fixedHeight = parseInt(this.tableHeight, 10);
      const maxHeight = parseInt(this.tableMaxHeight, 10);

      if (title && title.$el) {
        nonBodyHeight += title.$el.offsetHeight;
      }

      if (filters) {
        nonBodyHeight += filters.offsetHeight;
      }

      if (tableHeader && tableHeader.$el) {
        nonBodyHeight += tableHeader.$el.offsetHeight;
      }

      if (!fixedHeight && !maxHeight || this.tableAutoHeight) {
        if (!fixedHeight && !maxHeight && !this.tableAutoHeight) {
          warn('missing height/maxHeight/autoHeight property. Table height rendering may be negatively impacted.', this);
        }

        const _this$$el$getBounding = this.$el.getBoundingClientRect(),
              top = _this$$el$getBounding.top;

        const componentHeight = window.innerHeight - top - this.tableAutoHeightOffset;
        const bodyHeight = componentHeight - nonBodyHeight;

        if (this.scrollStore.pageMode) {
          if (!this.status || this.status === 'resolved') {
            this.bodyStyle = {
              maxHeight: '100%'
            };
            this.tableStyle = {
              maxHeight: '100%'
            };
          } else {
            this.bodyStyle = {
              height: `${bodyHeight}px`
            };
            this.tableStyle = {
              height: `${componentHeight}px`
            };
          }

          return this.$nextTick();
        }

        this.bodyStyle = {
          maxHeight: `${bodyHeight}px`
        };
        this.tableStyle = {
          maxHeight: `${componentHeight}px`
        };
        return this.$nextTick();
      }

      if (fixedHeight) {
        this.bodyStyle = {
          height: `${fixedHeight - nonBodyHeight}px`
        };
        this.tableStyle = {
          height: `${this.collapsed ? nonBodyHeight : fixedHeight}px`
        };
        return this.$nextTick();
      }

      if (maxHeight) {
        this.bodyStyle = {
          maxHeight: `${maxHeight - nonBodyHeight}px`
        };
        this.tableStyle = {
          maxHeight: `${maxHeight}px`
        };
      }

      return this.$nextTick();
    },

    addRow(row) {
      if (this.rowsMap.has(row[this.rowKey])) {
        warn(`row with ${this.rowKey} ${row[this.rowKey]} already exists.`, this);
        return;
      }

      this.rowsMap.set(row[this.rowKey], row);
      this.updateActiveTableData();
    },

    updateRow(row) {
      if (!this.rowsMap.has(row[this.rowKey])) {
        warn(`cannot find row with ${this.rowKey} ${row[this.rowKey]}.`, this);
        return;
      }

      this.rowsMap.set(row[this.rowKey], row);
      this.updateActiveTableData();
    },

    removeRow(row) {
      if (!this.rowsMap.has(row[this.rowKey])) {
        return;
      }

      this.rowsMap.delete(row[this.rowKey]);
      this.$delete(this.selectedMap, row[this.rowKey]);
      this.updateActiveTableData();
    }

  }
};

const __vue_script__$9 = script$9;

var __vue_render__$8 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleVisibilityChange,
      expression: "handleVisibilityChange"
    }],
    ref: "table",
    staticClass: "pendo-table",
    class: [(_obj = {
      'pendo-table--fit': _vm.fit,
      'pendo-table--striped': _vm.stripe,
      'pendo-table--border': _vm.border,
      'pendo-table--borderless': _vm.borderless,
      'pendo-table--scrollable-x': _vm.overflowX,
      'pendo-table--scrollable-y': _vm.overflowY,
      'pendo-table--page-mode-scroll': _vm.scrollStore.pageMode,
      'pendo-table--highlight-hover': _vm.highlightHoverRow,
      'pendo-table--condensed': _vm.condensed,
      'pendo-table--title': _vm.showTableTitle,
      'pendo-table--filters': !!_vm.$slots.filters || !!_vm.$scopedSlots.filters,
      'pendo-table--collapsible': _vm.collapsible,
      'is-underflowing': _vm.underflowX,
      'is-collapsed': _vm.collapsed,
      'is-loading': _vm.loading
    }, _obj["is-" + _vm.status] = Boolean(_vm.status), _obj)],
    style: _vm.tableStyle,
    attrs: {
      "id": _vm.id,
      "role": "grid",
      "aria-labelledby": _vm.title
    }
  }, [_vm.showTableTitle ? _c('table-title', {
    ref: "title",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header")];
      },
      proxy: true
    }, {
      key: "headerLeft",
      fn: function () {
        return [_vm._t("headerLeft")];
      },
      proxy: true
    }, {
      key: "headerRight",
      fn: function () {
        return [_vm._t("headerRight")];
      },
      proxy: true
    }, {
      key: "headerActions",
      fn: function () {
        return [_vm._t("headerActions")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.collapsed,
      expression: "!collapsed"
    }],
    staticClass: "pendo-table__content"
  }, [!!_vm.$slots.filters || !!_vm.$scopedSlots.filters ? _c('div', {
    ref: "filters",
    staticClass: "pendo-table__filters",
    style: _vm.scrollStore.pageMode && {
      top: _vm.scrollStore.stickyElementPositions.filters + "px"
    }
  }, [_vm._t("filters")], 2) : _vm._e(), _vm._v(" "), !!_vm.$slots.status || !!_vm.$scopedSlots.status ? _c('div', {
    staticClass: "pendo-table__status-container"
  }, [_vm._t("status")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading:material",
      value: {
        loading: _vm.loading,
        text: _vm.loadingText,
        spinnerProps: {
          color: '#3a3c45',
          background: '#FFFFFF',
          size: 48
        }
      },
      expression: "{\n                    loading,\n                    text: loadingText,\n                    spinnerProps: {\n                        color: '#3a3c45',\n                        background: '#FFFFFF',\n                        size: 48\n                    }\n                }",
      arg: "material"
    }]
  }, [_c('table-header', {
    ref: "tableHeader"
  }), _vm._v(" "), _c('table-body', {
    ref: "tableBody"
  }, [_c('template', {
    slot: "append"
  }, [_vm._t("append")], 2), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_vm._t("empty")], 2)], 2)], 1)])]), _vm._v(" "), _vm.resizable ? _c('div', {
    ref: "resizeBar",
    staticClass: "pendo-table__resize-bar",
    style: _vm.overflowX ? {
      paddingBottom: _vm.horizontalScrollbarHeight + "px"
    } : {}
  }) : _vm._e(), _vm._v(" "), _vm.manageColumns ? _c('pendo-column-chooser', {
    attrs: {
      "value-key": "columnKey",
      "disable-first": "",
      "visible": _vm.manageColumnStore.visible,
      "columns": _vm.manageColumnStore.columns,
      "available-columns": _vm.manageColumnStore.availableColumns,
      "placeholder": _vm.manageColumnsConfig.placeholder,
      "title": _vm.manageColumnsConfig.title,
      "description": _vm.manageColumnsConfig.description,
      "add-button-label": _vm.manageColumnsConfig.addButtonLabel,
      "confirm-button-config": _vm.manageColumnsConfig.confirmButtonConfig,
      "cancel-button-config": _vm.manageColumnsConfig.cancelButtonConfig,
      "all-selected-text": _vm.manageColumnsConfig.allSelectedText
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.manageColumnStore, "visible", $event);
      },
      "confirm": _vm.hideManageColumnsModal
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$8 = [];
const __vue_inject_styles__$9 = undefined;
const __vue_scope_id__$9 = undefined;
const __vue_is_functional_template__$9 = false;

function __vue_normalize__$9(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-table.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoTable = __vue_normalize__$9({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9);

export default PendoTable;
